var html = document.documentElement;
var body = document.body;
var lastMonth;
var lastGroup;
var timeout;
var st = 0;

cover();
subMenu();
featured();
feedLayout();
pagination();
// archive();
video();
gallery();
table();
burger();
subscriptionConfirmation();
podcastArchive();
podcastPlayers();


function podcastArchive() {
    'use strict';
    // Immutable durations for the migrated records, whose Ghost HTML predates data-duration.
    var legacyDurations = {"ep-20-atlassian-growing-ambition.mp3":630.397589,"ep-19-why-saas-is-like-walmart.mp3":1097.336422,"ep-18-why-empire-building-is-important.mp3":778.329,"ep-17-roblox-the-coming-ad-titan.mp3":946.400833,"ep-16-could-miami-become-a-world-class-tech-hub.mp3":975.945333,"ep-15-how-we-think.mp3":880.337167,"ep-14-the-bnpl-revolution.mp3":911.893089,"ep-13-boom-supersonic-getting-there-in-half-the-time.mp3":675.093089,"ep-12-geicos-of-the-21st-century.mp3":1423.057167,"ep-11-how-should-we-measure-progress.mp3":843.504589,"ep-10-investing-in-the-metaverse.mp3":1852.170667,"ep-9-valuation-portfolio-construction-and-lots-of-companies.mp3":3546.864589,"ep-8-lemonade-with-marcelo-lima-on-the-investing-city-podcast.mp3":3072.298,"ep-7-shopify-slack-and-more-on-the-investing-city-podcast.mp3":2887.533922,"ep-6-discovering-innovative-companies-with-marcelo-lima.mp3":3583.827833,"ep-5-growth-underwriter-marcelo-lima-on-valuing-saas-businesses-zoom-slack-clay-christensen-s-disruption-theory-ben-graham-s-investment-in-geico-and-more-originally-on-the-acquirers-podcast-by-tobias-carlisle.mp3":3863.756,"ep-4-on-innovation-our-portfolio-and-more-interview-with-ns-capital.mp3":2912.637589,"ep-3-on-avoiding-technology.mp3":197.418,"ep-2-buffett-s-world-war-ii-debut.mp3":423.795167,"ep-1-from-franchise-to-ordinary-business.mp3":1128.657167,"ep-0-introducing-increasing-returns.mp3":55.625333};
    document.querySelectorAll('.hh-podcast-source').forEach(function (source) {
        var original = source.content.querySelector('audio[src]');
        if (!original) return;
        var url = new URL(original.getAttribute('src'), window.location.href);
        if (url.origin !== window.location.origin || !/^\/podcast\/audio\/[a-z0-9-]+\.mp3$/.test(url.pathname)) return;
        var audio = document.createElement('audio');
        audio.controls = true;
        audio.preload = 'none';
        audio.setAttribute('controlslist', 'nodownload');
        audio.src = url.pathname;
        var duration = Number(original.dataset.duration) || legacyDurations[url.pathname.split('/').pop()] || 0;
        audio.dataset.duration = duration;
        var label = source.parentElement.querySelector('.hh-podcast-listed-duration');
        if (label && duration) {
            var total = Math.floor(duration);
            label.textContent = (total >= 3600 ? Math.floor(total / 3600) + ':' + String(Math.floor(total % 3600 / 60)).padStart(2, '0') : Math.floor(total / 60)) + ':' + String(total % 60).padStart(2, '0');
        }
        source.replaceWith(audio);
    });
}

function podcastPlayers() {
    'use strict';
    // The header card replaces the old embed for this recording, without changing post content.
    var listenCard = document.querySelector('.hh-listen-card');
    if (listenCard) {
        var featuredSource = new URL(listenCard.querySelector('audio').getAttribute('src'), window.location.href).pathname;
        document.querySelectorAll('.single-content .hh-inline-podcast-card').forEach(function (legacy) {
            var legacyAudio = legacy.querySelector('audio[src]');
            if (legacyAudio && new URL(legacyAudio.getAttribute('src'), window.location.href).pathname === featuredSource) {
                legacy.remove();
            }
        });
    }
    var audios = Array.prototype.filter.call(document.querySelectorAll('audio[src]'), function (audio) {
        var source = new URL(audio.getAttribute('src'), window.location.href);
        return source.origin === window.location.origin && source.pathname.indexOf('/podcast/audio/') === 0;
    });

    function formatTime(seconds) {
        if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
        var total = Math.floor(seconds);
        var hours = Math.floor(total / 3600);
        var minutes = Math.floor((total % 3600) / 60);
        var remainder = String(total % 60).padStart(2, '0');
        return hours ? hours + ':' + String(minutes).padStart(2, '0') + ':' + remainder : minutes + ':' + remainder;
    }

    audios.forEach(function (audio) {
        var card = audio.closest('.hh-podcast-card, .hh-podcast-player-card, .hh-inline-podcast-card, .hh-listen-card');
        var title = card && card.querySelector('h2, h1, strong');
        if (!title) {
            var episodePage = audio.closest('.hh-podcast-episode-page');
            title = episodePage && episodePage.querySelector('h1');
        }
        var episodeName = title ? title.textContent.trim() : 'podcast episode';
        var listedDuration = Number(audio.dataset.duration) || 0;
        var player = document.createElement('div');
        player.className = 'hh-audio-player';
        player.setAttribute('role', 'group');
        player.setAttribute('aria-label', 'Player for ' + episodeName);
        var backIcon = '<svg viewBox="0 0 36 36" aria-hidden="true"><path d="M10 9a13 13 0 1 1-4 13M10 3v6h6"/></svg><span aria-hidden="true">10</span>';
        var forwardIcon = '<svg viewBox="0 0 36 36" aria-hidden="true"><path d="M26 9a13 13 0 1 0 4 13M26 3v6h-6"/></svg><span aria-hidden="true">10</span>';
        player.innerHTML = '<div class="hh-audio-controls">' +
            '<button class="hh-audio-play" type="button" aria-label="Play episode">' +
            '<svg class="hh-audio-icon-play" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l11-6.5z"/></svg>' +
            '<svg class="hh-audio-icon-pause" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5h4v14H7zm7 0h4v14h-4z"/></svg></button>' +
            '<button class="hh-audio-skip" type="button" data-skip="-10" aria-label="Back 10 seconds">' + backIcon + '</button>' +
            '<button class="hh-audio-skip" type="button" data-skip="10" aria-label="Forward 10 seconds">' + forwardIcon + '</button>' +
            '<span class="hh-audio-elapsed">0:00</span>' +
            '<input class="hh-audio-seek" type="range" min="0" max="100" step="0.1" value="0" aria-label="Seek in episode">' +
            '<span class="hh-audio-duration">0:00</span>' +
            '<label class="hh-audio-speed-control" title="Playback speed">' +
            '<svg class="hh-audio-speed-icon" viewBox="0 0 72 36" aria-hidden="true">' +
            '<path class="hh-audio-ship-flame" d="M15 14C10 13 7 16 2 18c5 2 8 5 13 4z"/>' +
            '<path class="hh-audio-ship-flame-core" d="M15 16 7 18l8 2z"/>' +
            '<path class="hh-audio-ship-flaps" d="M19 13V5h5l10 8zm0 10v8h5l10-8zM48 13l1-6h4l6 8zm0 10 1 6h4l6-8z"/>' +
            '<path class="hh-audio-ship-frame" d="M16 13h33c8 0 14 2 19 5-5 3-11 5-19 5H16z"/>' +
            '<path class="hh-audio-ship-grid" d="M25 13v10m9-10v10m9-10v10m9-9v8M17 18h47"/>' +
            '<path class="hh-audio-ship-engine" d="M16 15h-3v6h3"/>' +
            '</svg><select class="hh-audio-speed" aria-label="Playback speed">' +
            '<option value="0.75">0.75×</option><option value="1" selected>1×</option>' +
            '<option value="1.25">1.25×</option><option value="1.5">1.5×</option><option value="2">2×</option>' +
            '</select></label></div>' +
            '<span class="hh-audio-status" role="status" aria-live="polite"></span>';

        if (card && card.classList.contains('hh-listen-card')) {
            player.classList.add('hh-audio-player--feature');
            var controls = player.querySelector('.hh-audio-controls');
            var main = document.createElement('div');
            main.className = 'hh-listen-main';
            var waveform = document.createElement('div');
            waveform.className = 'hh-listen-waveform';
            waveform.style.setProperty('--hh-waveform', 'url("' + audio.dataset.waveform + '")');
            waveform.innerHTML = '<span class="hh-listen-wave-base" aria-hidden="true"></span><span class="hh-listen-wave-progress" aria-hidden="true"></span>';
            waveform.appendChild(controls.querySelector('.hh-audio-seek'));
            main.appendChild(controls.querySelector('.hh-audio-play'));
            main.appendChild(waveform);
            var toolbar = document.createElement('div');
            toolbar.className = 'hh-listen-toolbar';
            var skips = document.createElement('div');
            skips.className = 'hh-listen-skips';
            controls.querySelectorAll('.hh-audio-skip').forEach(function (button) { skips.appendChild(button); });
            var time = document.createElement('div');
            time.className = 'hh-listen-time';
            time.appendChild(controls.querySelector('.hh-audio-elapsed'));
            var separator = document.createElement('span');
            separator.setAttribute('aria-hidden', 'true');
            separator.textContent = ' / ';
            time.appendChild(separator);
            time.appendChild(controls.querySelector('.hh-audio-duration'));
            toolbar.appendChild(skips);
            toolbar.appendChild(time);
            toolbar.appendChild(controls.querySelector('.hh-audio-speed-control'));
            controls.appendChild(main);
            controls.appendChild(toolbar);
        }

        var play = player.querySelector('.hh-audio-play');
        var seek = player.querySelector('.hh-audio-seek');
        var elapsed = player.querySelector('.hh-audio-elapsed');
        var total = player.querySelector('.hh-audio-duration');
        var speed = player.querySelector('.hh-audio-speed');
        var status = player.querySelector('.hh-audio-status');
        var pendingSeek = null;
        var loadingMetadata = false;

        function duration() {
            return Number.isFinite(audio.duration) && audio.duration > 0 ? audio.duration : listedDuration;
        }

        function update() {
            var length = duration();
            seek.max = String(length || 100);
            seek.value = String(Math.min(audio.currentTime || 0, length || 100));
            seek.disabled = !length;
            seek.setAttribute('aria-valuetext', formatTime(audio.currentTime) + ' of ' + formatTime(length));
            var progress = (length ? Math.min(audio.currentTime / length, 1) * 100 : 0) + '%';
            seek.style.setProperty('--hh-audio-progress', progress);
            player.style.setProperty('--hh-audio-progress', progress);
            elapsed.textContent = formatTime(audio.currentTime);
            total.textContent = formatTime(length);
            play.dataset.playing = String(!audio.paused);
            play.setAttribute('aria-label', (audio.paused ? 'Play ' : 'Pause ') + episodeName);
        }

        function seekTo(seconds) {
            var target = Math.max(0, Math.min(seconds, duration() || seconds));
            if (audio.readyState === 0) {
                pendingSeek = target;
                if (!loadingMetadata) {
                    loadingMetadata = true;
                    audio.addEventListener('loadedmetadata', function () {
                        audio.currentTime = Math.min(pendingSeek, duration());
                        pendingSeek = null;
                        loadingMetadata = false;
                        update();
                    }, {once: true});
                    audio.preload = 'metadata';
                    audio.load();
                }
            } else {
                audio.currentTime = target;
                update();
            }
        }

        play.addEventListener('click', function () {
            if (!audio.paused) {
                audio.pause();
                return;
            }
            audios.forEach(function (other) {
                if (other !== audio) other.pause();
            });
            status.textContent = '';
            audio.play().catch(function () {
                status.textContent = 'Audio could not play.';
            });
        });
        player.querySelectorAll('[data-skip]').forEach(function (button) {
            button.addEventListener('click', function () {
                seekTo((pendingSeek === null ? audio.currentTime : pendingSeek) + Number(button.dataset.skip));
            });
        });
        seek.addEventListener('input', function () {
            seekTo(Number(seek.value));
        });
        speed.addEventListener('change', function () {
            audio.playbackRate = Number(speed.value);
        });
        ['timeupdate', 'durationchange', 'loadedmetadata', 'play', 'pause', 'ended'].forEach(function (event) {
            audio.addEventListener(event, update);
        });
        audio.addEventListener('error', function () {
            pendingSeek = null;
            loadingMetadata = false;
            status.textContent = 'Audio is unavailable.';
        });

        audio.setAttribute('controlslist', 'nodownload');
        audio.parentNode.insertBefore(player, audio);
        player.appendChild(audio);
        audio.controls = false;
        player.classList.add('hh-audio-ready');
        if (card) {
            var download = card.querySelector('.hh-podcast-download');
            if (download) download.remove();
        }
        update();
    });
}

function subscriptionConfirmation() {
    'use strict';
    var subscriptionForm = document.querySelector('[data-subscribe-default]');
    var confirmation = document.querySelector('[data-subscribe-confirmed]');
    if (!subscriptionForm || !confirmation) return;

    var params = new URLSearchParams(window.location.search);
    if (params.get('action') !== 'subscribe' || params.get('success') !== 'true') return;

    subscriptionForm.hidden = true;
    confirmation.hidden = false;
    document.title = 'Subscription confirmed — Heller House';
    window.history.replaceState({}, '', window.location.pathname + window.location.hash);

    var heading = confirmation.querySelector('h1');
    if (heading) heading.focus();
}

window.addEventListener('scroll', function () {
    'use strict';
    if (body.classList.contains('home-template') && body.classList.contains('with-full-cover') && !document.querySelector('.cover').classList.contains('half')) {
        if (timeout) {
            window.cancelAnimationFrame(timeout);
        }
        timeout = window.requestAnimationFrame(portalButton);
    }
});

if (document.querySelector('.cover') && document.querySelector('.cover').classList.contains('half')) {
    body.classList.add('portal-visible');
}

function portalButton() {
    'use strict';
    st = window.scrollY;

    if (st > 300) {
        body.classList.add('portal-visible');
    } else {
        body.classList.remove('portal-visible');
    }
}

function cover() {
    'use strict';
    var cover = document.querySelector('.cover');
    if (!cover) return;

    imagesLoaded(cover, function () {
        cover.classList.remove('image-loading');
    });

    document.querySelector('.cover-arrow').addEventListener('click', function () {
        var element = cover.nextElementSibling;
        element.scrollIntoView({behavior: 'smooth', block: 'start'});
    });
}

function subMenu() {
    'use strict';
    var nav = document.querySelector('.header-nav');
    var items = nav.querySelectorAll('.menu-item');

    function getSiblings(el, filter) {
        var siblings = [];
        while (el= el.nextSibling) { if (!filter || filter(el)) siblings.push(el); }
        return siblings;
    }

    function exampleFilter(el) {
        return el.nodeName.toLowerCase() == 'a';
    }

    if (items.length > 5) {
        var separator = items[4];

        var toggle = document.createElement('button');
        toggle.setAttribute('class', 'button-icon menu-item-button menu-item-more');
        toggle.setAttribute('aria-label', 'More');
        toggle.innerHTML = '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M21.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM13.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM5.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0z"></path></svg>';

        var wrapper = document.createElement('div');
        wrapper.setAttribute('class', 'sub-menu');

        var children = getSiblings(separator, exampleFilter);

        children.forEach(function (child) {
            wrapper.appendChild(child);
        });

        toggle.appendChild(wrapper);
        separator.parentNode.appendChild(toggle);

        toggle.addEventListener('click', function () {
            if (window.getComputedStyle(wrapper).display == 'none') {
                wrapper.style.display = 'block';
                wrapper.classList.add('animate__animated', 'animate__bounceIn');
            } else {
                wrapper.classList.add('animate__animated', 'animate__zoomOut');
            }
        });

        wrapper.addEventListener('animationend', function (e) {
            wrapper.classList.remove('animate__animated', 'animate__bounceIn', 'animate__zoomOut');
            if (e.animationName == 'zoomOut') {
                wrapper.style.display = 'none';
            }
        });
    }
}

function featured() {
    'use strict';
    var feed = document.querySelector('.featured-feed');
    if (!feed) return;

    tns({
        container: feed,
        controlsText: [
            '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M20.547 22.107L14.44 16l6.107-6.12L18.667 8l-8 8 8 8 1.88-1.893z"></path></svg>',
            '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M11.453 22.107L17.56 16l-6.107-6.12L13.333 8l8 8-8 8-1.88-1.893z"></path></svg>',
        ],
        gutter: 30,
        loop: false,
        nav: false,
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 2,
            },
            992: {
                items: 3,
            },
        },
    });
}

function feedLayout() {
    'use strict';
    var wrapper = document.querySelector('.feed-layout');
    if (!wrapper) return;

    var feed = document.querySelector('.post-feed');

    document.querySelector('.feed-layout-headline').addEventListener('click', function () {
        wrapper.classList.remove('expanded');
        feed.classList.remove('expanded');
        localStorage.setItem('edition_layout', 'compact');
    });

    document.querySelector('.feed-layout-expanded').addEventListener('click', function () {
        wrapper.classList.add('expanded');
        feed.classList.add('expanded');
        localStorage.removeItem('edition_layout');
    });
}

function pagination() {
    'use strict';
    if (!body.classList.contains('paged-next')) return;

    var button = document.querySelector('.infinite-scroll-button');
    var nextLink = document.querySelector('.pagination .older-posts');
    var memoGrid = document.querySelector('.hh-memo-grid');
    var legacyFeed = document.querySelector('.post-feed');

    if (!button || !nextLink || (!memoGrid && !legacyFeed)) return;

    var container = memoGrid ? '.hh-memo-grid' : '.post-feed';
    var item = memoGrid ? '.hh-memo-card' : '.feed';
    var infScroll = new InfiniteScroll(container, {
        append: item,
        button: '.infinite-scroll-button',
        debug: false,
        hideNav: '.pagination',
        history: false,
        path: '.pagination .older-posts',
        scrollThreshold: false,
    });

    infScroll.on('request', function (_path, _fetchPromise) {
        button.classList.add('loading');
    });

    infScroll.on('append', function (_response, _path, items) {
        button.classList.remove('loading');

        if (memoGrid) return;
        if (items.length) items[0].classList.add('feed-paged');
        archive(items);
    });

    infScroll.on('last', function () {
        button.classList.remove('loading');
    });

    infScroll.on('error', function () {
        button.classList.remove('loading');
    });
}

function archive(data) {
    'use strict';
    if (!body.classList.contains('logged-in')) return;

    var feed = document.querySelector('.post-feed');
    var posts = data || document.querySelectorAll('.feed');

    posts.forEach(function (post) {
        var current = post.getAttribute('data-month');
        if (current != lastMonth) {
            var month = document.createElement('div');
            month.className = 'feed-month';
            month.innerText = current;

            var group = document.createElement('div');
            group.className = 'feed-group';
            group.appendChild(month);

            feed.insertBefore(group, post);

            group.appendChild(post);

            lastMonth = current;
            lastGroup = group;
        } else {
            lastGroup.appendChild(post);
        }
    });
}

function video() {
    'use strict';
    const sources = [
        '.single-content iframe[src*="youtube.com"]',
        '.single-content iframe[src*="youtube-nocookie.com"]',
        '.single-content iframe[src*="player.vimeo.com"]',
        '.single-content iframe[src*="kickstarter.com"][src*="video.html"]',
        'object',
        'embed',
    ];

    reframe(document.querySelectorAll(sources.join(',')));
}

function gallery() {
    'use strict';
    pswp(
        '.kg-gallery-container',
        '.kg-gallery-image',
        '.kg-gallery-image > img',
        false,
        true
    );
}

function table() {
    'use strict';
    if (!body.classList.contains('post-template') && !body.classList.contains('page-template')) return;

    var tables = document.querySelectorAll('.single-content .table');

    tables.forEach(function (table) {
        var labels = [];

        table.querySelectorAll('thead th').forEach(function (label) {
            labels.push(label.textContent);
        });

        table.querySelectorAll('tr').forEach(function (row) {
            row.querySelectorAll('td').forEach(function (column, index) {
                column.setAttribute('data-label', labels[index]);
            });
        });
    });
}

function burger() {
    'use strict';
    document.querySelector('.burger').addEventListener('click', function () {
        if (!body.classList.contains('menu-opened')) {
            body.classList.add('menu-opened');
        } else {
            body.classList.remove('menu-opened');
        }
    });
}

function pswp(container, element, trigger, caption, isGallery) {
    var parseThumbnailElements = function (el) {
        var items = [],
            gridEl,
            linkEl,
            item;

        el
            .querySelectorAll(element)
            .forEach(function (v) {
                gridEl = v;
                linkEl = gridEl.querySelector(trigger);

                item = {
                    src: isGallery
                        ? gridEl.querySelector('img').getAttribute('src')
                        : linkEl.getAttribute('href'),
                    w: 0,
                    h: 0,
                };

                if (caption && gridEl.querySelector(caption)) {
                    item.title = gridEl.querySelector(caption).innerHTML;
                }

                items.push(item);
            });

        return items;
    };

    var openPhotoSwipe = function (index, galleryElement) {
        var pswpElement = document.querySelectorAll('.pswp')[0],
            gallery,
            options,
            items;

        items = parseThumbnailElements(galleryElement);

        options = {
            closeOnScroll: false,
            history: false,
            index: index,
            shareEl: false,
            showAnimationDuration: 0,
            showHideOpacity: true,
        };

        gallery = new PhotoSwipe(
            pswpElement,
            PhotoSwipeUI_Default,
            items,
            options
        );
        gallery.listen('gettingData', function (index, item) {
            if (item.w < 1 || item.h < 1) {
                // unknown size
                var img = new Image();
                img.onload = function () {
                    // will get size after load
                    item.w = this.width; // set image width
                    item.h = this.height; // set image height
                    gallery.updateSize(true); // reinit Items
                };
                img.src = item.src; // let's download image
            }
        });
        gallery.init();
    };

    var onThumbnailsClick = function (e) {
        e.preventDefault();

        var siblings = e.target.closest(container).querySelectorAll(element);
        var nodes = Array.prototype.slice.call(siblings);
        var index = nodes.indexOf(e.target.closest(element));
        var clickedGallery = e.target.closest(container);

        openPhotoSwipe(index, clickedGallery);

        return false;
    };

    // container = document.querySelector(container);
    // if (!container) return;

    var triggers = document.querySelectorAll(trigger);
    triggers.forEach(function (trig) {
        trig.addEventListener('click', function (e) {
            onThumbnailsClick(e);
        });
    });
}
